// Treatment lifted from the approved Flash vendor prototype; chart palettes retain Tableau semantics.
export const inventoryBand = {
  bgcolor: '#0f464f',
  color: '#fff',
  px: '6px',
  py: '5px',
  minHeight: 25,
  fontSize: 12,
  fontWeight: 600,
  lineHeight: 1.2,
  textAlign: 'center',
} as const;
